import { useState } from 'react';
import {
    FormControl,
    FormLabel,
    Box,
    Stack,
    FormErrorMessage,
} from '@chakra-ui/react';
import { Field } from 'formik';
import useGetVisibilityGroups from '../../queries/useGetVisibilityGroups';
import { useCompanyForm } from '../../hooks/useCompanyForm';
import DropDown from '@/components/forms/new/formikFormFields/DropDown';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';
import { FORM_FIELD_PATHS } from '../../constants';
import { useSelector } from 'react-redux';

const EntityVisibilityGroupDropdown = ({ darkMode, errors }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { formData, updateFormData } = useCompanyForm();
    const { adminID } = useSelector((state) => state.login);
    const { data: visibilityGroups, isLoading } =
        useGetVisibilityGroups(adminID);

    // Compose dropdown options
    const options = [
        {
            label: '- Not Allocated -',
            value: 'Not Allocated',
            id: 'Not Allocated',
            name: '- Not Allocated -',
        },
        ...(visibilityGroups?.map((item) => ({
            label: item.name,
            value: item.id,
            id: item.id,
            name: item.name,
        })) || []),
    ];

    const handleSelectChange = (item) => {
        updateFormData(
            FORM_FIELD_PATHS.VISIBILITY_GROUP_ID,
            item.value === 'Not Allocated' ? null : item.value,
        );
    };

    const hasError = !!errors?.visibilityGroupID;

    return (
        <FormControl
            sx={{ margin: '0 !important', paddingInline: 4 }}
            isInvalid={hasError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <FormLabel sx={formLabelStyling(darkMode)}>
                    Visibility Group
                </FormLabel>
                <Box flex={1} maxWidth="400px">
                    <Field
                        component={DropDown}
                        id={FORM_FIELD_PATHS.VISIBILITY_GROUP_ID}
                        name={FORM_FIELD_PATHS.VISIBILITY_GROUP_ID}
                        data={options}
                        shownValue="label"
                        currentId={
                            formData?.visibilityGroupID ?? 'Not Allocated'
                        }
                        selectedId="value"
                        placeholder="Select visibility group"
                        handleSelectChange={handleSelectChange}
                        width="100%"
                        isLoading={isLoading}
                        darkMode={darkMode}
                    />
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Restrict access to this company to defined groups of TCAP Administrators. Configure Visibility Groups under the Organisations menu."
                        ariaLabel="visibility-group-dropdown-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
            <FormErrorMessage>{errors?.visibilityGroupID}</FormErrorMessage>
        </FormControl>
    );
};

export default EntityVisibilityGroupDropdown;
